import React, {useRef, useState, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Col, Row, Card, Form} from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import Navigation from "../components/Navigation";
import Heading from "../components/Heading";
import Footer from "../components/Footer";
import {useNavigate} from "react-router-dom";
import '../assets/css/react-draft.css'
import {addLettersTemplate, resetAddLettersTemplate} from "../actions/LetterNoticesActions";
import AlertModal from "../components/AlertModal";
import Loader from "../components/Loader";
import {getCustomDynamicArray} from "../utils";
import {getAllLettersTemplatesList} from "../actions/ConfigActions";
import CdkAppEditor from "../components/CdkEditor/CdkAppEditor";

const CreateNewTemplate = (props) => {
    const history = useNavigate();
    const titleRef = useRef();
    const dispatch = useDispatch();
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    })
    const [alertDuplicate, setAlertDuplicate] = useState({
        display: false,
        type: "",
        message: ""
    });
    const [newCustomDynamicFields, setNewCustomDynamicFields] = useState([])
    const desciptionRef = useRef();

    const addTemplateDetails = useSelector(state => state.addLettersTemplate)
    const getAllLettersTemplate = useSelector(state => state.getAllLettersTemplateList);
    const {loading} = addTemplateDetails

    useEffect(() => {
        if (addTemplateDetails.letters_template === true) {
            dispatch(resetAddLettersTemplate())
            history('/letters-notices',{state:{success: "1"}})
        } if (addTemplateDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Couldn't add template"
            })
        }
    }, [addTemplateDetails]);

    useEffect(() => {
        dispatch(getAllLettersTemplatesList(1000, 1));
    }, []);

    const [fieldIsValid, setFieldIsValid] = useState({
        isDocumentValid: false,
        isTitleValid: false,
        isDescriptionValid: false,
        isTextValid: false,
        isCopyValid: true,
    });
    const [fieldData, setFieldData] = useState({
        dataDocument: null,
        dataTitle: null,
        dataDescription: null,
        dataText: "",
        dataCopy: 1,
        isSignRequired: false,
    });

    const checkCdkEditor = (data) => {
        if (data[0].length < 10) {
            setFieldIsValid({
                ...fieldIsValid,
                isTextValid: false,
            });
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isTextValid: true,
            });
            setFieldData({
                ...fieldData,
                dataText: data[0],
                wysiwygRawData: data[1],
            })
        }
    };


    const titleKeyPress = (event) => {
        event.preventDefault();
        if (!/^(?=.*[a-zA-Z\d\n].*)[a-zA-Z \d!@#$%&*.,-]{1,100}$/.test(titleRef.current.value)) {
            setFieldIsValid({
                ...fieldIsValid,
                isTitleValid: false,
            });
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isTitleValid: true,
            });
        }
    }

    const descriptionKeyPress = (event) => {
        event.preventDefault();
        if (!/.*?$/.test(desciptionRef.current.value)) {
            setFieldIsValid({
                ...fieldIsValid,
                isDescriptionValid: false,
            });
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isDescriptionValid: true,
            });
        }
    }

    const selectCopy = (data) => {
        setFieldIsValid({
            ...fieldIsValid,
            isCopyValid: true,
        });
        setFieldData({
            ...fieldData,
            dataCopy: data
        })
    }

    const openLink = () => {
        history('/letters-notices')
    }

    const submitHandler = (e) => {
        e.preventDefault();

        const {isDuplicatedName} = checkDuplicate();

        if (isDuplicatedName) {
            setAlertDuplicate({
                display: true,
                type: "error",
                message: "The title is not unique."
            })

            return;
        }

        const filteredNewCustomDynamicFields = newCustomDynamicFields.length ? getCustomDynamicArray(newCustomDynamicFields, fieldData.dataText) : [];

        dispatch(addLettersTemplate(null, titleRef.current.value, desciptionRef.current.value, 1, fieldData.dataText, fieldData.dataCopy === 1, fieldData.isSignRequired, filteredNewCustomDynamicFields, fieldData.wysiwygRawData));
    }

    const checkDuplicate = () => {
        const allTemplateList = getAllLettersTemplate?.letter_template_list ?? [];

        if (!allTemplateList?.length) {
            return {isDuplicatedName: false};
        }

        return allTemplateList.reduce((acc, letter) => {
            if (letter.title?.trim() === titleRef.current.value?.trim()) {
                acc.isDuplicatedName = true;
            }

            return acc;
        }, {isDuplicatedName: false})
    }

    const closeDuplicateAlert = () => {
        setAlertDuplicate({ display: false });
    }

    const onReset = (e) => {
        e.preventDefault()
        window.location.href = "/create-new-template"
    }

    const closeAlert = () => {
        setAlertModal({
            display: false
        })
        dispatch(resetAddLettersTemplate())
    }

    const setIsSignatureRequired = () => {
        setFieldData({ ...fieldData, isSignRequired: !fieldData.isSignRequired });
    }

    const pageName = 'letters';

    return (
        <>
            <Row className="sidebar-background">
                {alertModal.display &&
                    <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>}
                {loading && <Loader/>}
                {alertDuplicate.display &&
                    <AlertModal heading={alertDuplicate.message} type={alertDuplicate.type}
                                result={closeDuplicateAlert}/>}
                <div className="float-left-child sidebar app-spacing">
                    <Sidebar pageDetails={pageName}/>
                </div>
                <div className="float-right-child app-background app-spacing">
                    <Navigation/>
                    <Heading group="create_new_template" title="Create New Template" result={openLink}/>
                    <Row className="app-body-add-document background-1">
                        <Row className="background-1">
                            <Card className="card-body-default">
                                <form>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div className="document-form">
                                                <label htmlFor="document_title" id="documentTitleLabel"
                                                       className="form-label form-spacing">
                                                    Title<span className="asterics">*</span></label>
                                                <input ref={titleRef} onChange={titleKeyPress}
                                                       type="text" autoComplete="off"
                                                       className={!fieldIsValid.isTitleValid ?
                                                           "input-error-form input-spacing" : "input-valid-form input-spacing"}
                                                       placeholder="Enter Title"
                                                       id="document_title"/>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div
                                                className={!fieldIsValid.isDescriptionValid ? "document-form-textarea-error"
                                                    : "document-form-textarea"}
                                            >
                                                <span className="text-label form-spacing">
                                                    Description<span className="asterics">*</span></span>
                                                <textarea ref={desciptionRef} onChange={descriptionKeyPress}
                                                          className="textarea-input-error textarea-spacing"
                                                          placeholder="Enter Description" rows="4"
                                                          id="document_title"/>
                                            </div>
                                        </Col>

                                    </Row>
                                    <Row className="background-1">
                                        <div className="document-form padding-left-unset padding-right-unset">
                                            <CdkAppEditor
                                                result={checkCdkEditor}
                                                documentText={''}
                                                dynamicValue={true}
                                                setNewCustomDynamicFields={setNewCustomDynamicFields}
                                                realOnly={false}
                                            />
                                        </div>
                                    </Row>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset hardcopy-div">
                                            <div className="document-form">
                                                <div className="label-form-checkbox">
                                                    Hardcopy Required? <span className="asterics">*</span>
                                                </div>
                                                <div className="form-checkbox">
                                                    <Form.Check
                                                        className="float-left-child"
                                                        name="hardcopy"
                                                        label="Yes"
                                                        type="radio"
                                                        id="1"
                                                        defaultChecked={fieldData.dataCopy === 1}
                                                        onClick={() => selectCopy(1)}
                                                    />
                                                    <Form.Check
                                                        className="float-right-child"
                                                        name="hardcopy"
                                                        label="No"
                                                        type="radio"
                                                        id="0"
                                                        defaultChecked={fieldData.dataCopy === 0}
                                                        onClick={() => selectCopy(0)}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div className="document-form">
                                                <Form.Check
                                                    className="template-check"
                                                    name="new_template"
                                                    label="Require a signature for letters created from this template?"
                                                    type="checkbox"
                                                    id="1"
                                                    checked={fieldData.isSignRequired}
                                                    onClick={() => setIsSignatureRequired()}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    {(
                                            !fieldIsValid.isTitleValid
                                            || !fieldIsValid.isDescriptionValid
                                            || !fieldIsValid.isTextValid
                                            || !fieldIsValid.isCopyValid
                                        )
                                        &&
                                        <Row className="background-1 document-form submit-buttons">
                                            <Col lg={{span: 2}} className="padding-left-unset">
                                                <button disabled={true} className="button-solid button-inactive">
                                                    Create
                                                </button>
                                            </Col>
                                            <Col lg={{span: 2}} className="padding-right-unset">
                                                <button onClick={onReset}
                                                        className="button-solid button-transparent-active">
                                                    Reset
                                                </button>
                                            </Col>
                                        </Row>}
                                    {(
                                            fieldIsValid.isTitleValid
                                            && fieldIsValid.isDescriptionValid
                                            && fieldIsValid.isTextValid
                                            && fieldIsValid.isCopyValid
                                        )
                                        &&
                                        <Row className="background-1 document-form submit-buttons">
                                            <Col lg={{span: 2}} className="padding-left-unset">
                                                <button className="button-solid button-active"
                                                        onClick={submitHandler}
                                                >
                                                    Create
                                                </button>
                                            </Col>
                                            <Col lg={{span: 2}} className="padding-right-unset">
                                                <button className="button-solid button-transparent-active"
                                                        onClick={onReset}
                                                >
                                                    Reset
                                                </button>
                                            </Col>
                                        </Row>}
                                </form>
                                <Footer/>
                            </Card>
                        </Row>
                    </Row>

                </div>
            </Row>
        </>
    );
}

export default CreateNewTemplate;